import { useLanguage } from '../context/LanguageContext';

/**
 * Hook to get translated product content
 * Falls back to original product data if translation not available
 */
export const useProductTranslation = (product) => {
  const { getProductTranslation, language } = useLanguage();

  if (!product) return product;

  return {
    ...product,
    // Use translated values if available, otherwise use original
    name: getProductTranslation(product.slug, 'name') || product.name,
    short_description: getProductTranslation(product.slug, 'short_description') || product.short_description,
    description: getProductTranslation(product.slug, 'description') || product.description,
    technical_features: getProductTranslation(product.slug, 'technical_features') || product.technical_features,
  };
};
